// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"LoyaltyTrx_formGroup__lazU4"};